/*======================================================================================================================
  * Bluebell: src/app/state/results-filters/results-filter.selectors.ts
  * Last Edited: 20/01/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromResultsFilters from '@state/results-filters/results-filter.reducer';


export const selectResultsFilterState = createFeatureSelector<fromResultsFilters.State>(fromResultsFilters.featureKey);

export const selectResultsFilterIds = createSelector(
  selectResultsFilterState,
  fromResultsFilters.getIds
);

export const selectResultsFilterEntities = createSelector(
  selectResultsFilterState,
  fromResultsFilters.getEntities
);

export const selectAllResultsFilters = createSelector(
  selectResultsFilterState,
  fromResultsFilters.getAll
);

export const selectResultsFilterTotal = createSelector(
  selectResultsFilterState,
  fromResultsFilters.getTotal
);
export const selectActiveResultsFilterId = createSelector(
  selectResultsFilterState,
  fromResultsFilters.getActiveFilterId
);

export const selectAvailableResultsFilters = createSelector(
  selectResultsFilterState,
  fromResultsFilters.getAvailableFilters
);

/* Complex Selectors */

export const selectActiveResultsFilter = createSelector(
  selectResultsFilterState,
  selectActiveResultsFilterId,
  (state: fromResultsFilters.State) => state.activeFilterID ? (state.entities[state.activeFilterID] || null) : null
);
